import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class CostGreaterThanPriceError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.items.price.cost-greater-than-price-error');
    }
}
